import React, {useState} from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {
  type BaseItemPickerObject,
  StyledPickerUL,
} from 'app/general/widgets/SimpleItemPickerList/SimpleItemPickerList';
import {SimpleItemRenderItems} from 'app/general/widgets/SimpleItemPickerList/SimpleItemRenderItems';
import StateButton from 'app/general/widgets/StateButton';
import {useCreateTeams} from 'app/teams/api';
import {HOME_WELCOME_IMPORT} from 'app/urls';
import {gt, ngt} from 'app/utils/i18n';

import {SmallTextSpan, WelcomeStructure} from './WelcomeStructure';

import type {WithRouterProps} from 'react-router';

export const WelcomeDashboard = (props: WithRouterProps) => (
  <WelcomeStructure {...props} currentStep={1}>
    {({onNext}) => <SweetSuperchargeTeams onNext={onNext} />}
  </WelcomeStructure>
);

const SUGGESTED_TEAMS: Array<BaseItemPickerObject> = [
  {
    name: 'Management',
    url: 'management',
    content_type: 'team',
    description: '',
  },
  {name: 'Marketing', url: 'marketing', content_type: 'team', description: ''},
  {name: 'Sales', url: 'sales', content_type: 'team', description: ''},
  {
    name: 'Operations',
    url: 'operations',
    content_type: 'team',
    description: '',
  },
  {
    name: 'Accounting',
    url: 'accounting',
    content_type: 'team',
    description: '',
  },
  {name: 'HR', url: 'hr', content_type: 'team', description: ''},
  {name: 'IT', url: 'it', content_type: 'team', description: ''},
  {name: 'Customer Service', url: 'cs', content_type: 'team', description: ''},
];

type Props = {
  onNext: (location: string) => unknown;
};

const SweetSuperchargeTeams = ({onNext}: Props) => {
  const [selected, setSelected] = useState<Array<BaseItemPickerObject>>([]);

  const [createTeams, {isUninitialized}] = useCreateTeams();

  const onAddTeams = (items: Array<BaseItemPickerObject>) =>
    createTeams(items)
      .unwrap()
      .then(() => onNext(HOME_WELCOME_IMPORT));

  return (
    <>
      <div className="row">
        <div className="col">
          <p>
            {gt(
              "Select any teams that you have in your company and we'll create" +
                ' them for you.'
            )}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-sm m-2">
          <StyledPickerUL>
            <SimpleItemRenderItems
              resultsFingerprint={0}
              showDescription={false}
              allResults={SUGGESTED_TEAMS}
              selected={selected.map((item) => item)}
              setSelected={setSelected}
              addItemProps={() => Object.freeze({})}
            />
          </StyledPickerUL>
        </div>
      </div>
      <div className="row mt-4 justify-content-end">
        <SmallTextSpan className="col-sm-auto m-1 mb-3">
          {gt(
            'Teams control who can see your procedures, processes and policies.'
          )}
        </SmallTextSpan>
        <div className="col-sm-auto">
          <LazyTooltip
            tooltip={gt('Start using SweetProcess without creating any teams.')}
          >
            <button
              className="btn text-secondary btn-link mr-2"
              onClick={() => onNext(HOME_WELCOME_IMPORT)}
            >
              {gt('Skip')}
            </button>
          </LazyTooltip>
          <StateButton
            disabled={selected.length === 0 || !isUninitialized}
            busyText={gt('Adding teams...')}
            className="btn btn btn-primary"
            onClick={() => onAddTeams(selected)}
          >
            {ngt('Add Team', 'Add Teams', selected.length)}
          </StateButton>
        </div>
      </div>
    </>
  );
};
